module.exports = __webpack_public_path__ + "static/media/carousel2-.238463eb.jpg";